import { DeliveryMethod, OrderFields } from "../../../constants";
import type { TOrderFormData } from "../../../models/orderForm";
import type { TPrefillInfoParams } from "./types";

const getPrefillPackageData = ({
  prefill,
  affiliate,
  userAddress,
  storedData,
}: TPrefillInfoParams): Partial<TOrderFormData> => {
  const prefillAddressCountryCode = prefill?.address?.countryCode;
  const prefillAddressCountry = prefill?.address?.country;
  const prefillLockerCountryCode = prefill?.locker?.countryCode;
  const prefillLockerCountry = prefill?.locker?.country;

  const prefillCountryCode =
    prefill?.deliveryMethod === DeliveryMethod.PudoToDoor || prefill?.deliveryMethod === DeliveryMethod.DoorToDoor
      ? prefillAddressCountryCode
      : prefillLockerCountryCode;

  const prefillCountry =
    prefill?.deliveryMethod === DeliveryMethod.PudoToDoor || prefill?.deliveryMethod === DeliveryMethod.DoorToDoor
      ? prefillAddressCountry
      : prefillLockerCountry;

  const startingCountry =
    storedData?.[OrderFields.STARTING_COUNTRY] ?? affiliate?.startingCountry ?? userAddress?.countryCode;
  const startingCountryName = storedData?.[OrderFields.STARTING_COUNTRY_NAME] ?? userAddress?.country;
  const destinationCountry =
    prefillCountryCode ?? affiliate?.destinationCountry ?? storedData?.[OrderFields.DESTINATION_COUNTRY];
  const destinationCountryName = prefillCountry ?? storedData?.[OrderFields.DESTINATION_COUNTRY_NAME];
  const packageSize = storedData?.[OrderFields.PACKAGE_SIZE] ?? affiliate?.packageSize;
  const packageWeight = storedData?.[OrderFields.PACKAGE_WEIGHT];

  const deliveryMethod =
      (prefill?.deliveryMethod ?? storedData?.[OrderFields.DELIVERY_METHOD] ?? affiliate?.deliveryMethod) as DeliveryMethod | null | undefined;

  const valuesToPrefill: Partial<TOrderFormData> = {
    [OrderFields.STARTING_COUNTRY]: startingCountry,
    [OrderFields.STARTING_COUNTRY_NAME]: startingCountryName,
    [OrderFields.DESTINATION_COUNTRY]: destinationCountry,
    [OrderFields.DESTINATION_COUNTRY_NAME]: destinationCountryName,
    [OrderFields.PACKAGE_SIZE]: packageSize,
    [OrderFields.PACKAGE_WEIGHT]: packageWeight,
    [OrderFields.DELIVERY_METHOD]: deliveryMethod,
  };

  return valuesToPrefill;
};
export default getPrefillPackageData;
